import React, { useEffect, useState } from 'react'
import useStore from 'store'
import { useHistory } from 'react-router-dom'
import { ICollegeNews } from 'store/interface'
import { addRlog } from 'utils/util'
import { MESSAGE_RLOG } from 'constants/index'
import s from './index.module.less'
import icon from './images/icon.svg'

interface INewsList {
  list: ICollegeNews[]
  title: string
  id: number
  max?: number
}

const CollegeNews: React.FC<{}> = () => {
  const history = useHistory()
  const [newsList, setNewsList] = useState<INewsList[]>([
    { title: '高考资讯', list: [], id: 2 },
    { title: '志愿讲堂', list: [], id: 3 },
    { title: '招办动态', list: [], id: 1, max: 4 }
  ])
  const { state } = useStore()

  const msgClick = (type, title) => {
    addRlog('click', {
      click_location: type,
      [MESSAGE_RLOG[type]]: title
    })
  }

  const toDetail = (id) => {
    history.push({
      pathname: `/moreDetail`,
      search: `?type=${id}`
    })
  }

  useEffect(() => {
    // cms获取投放列表
    setNewsList([
      { title: '高考资讯', list: state.cmsData.collegeNews || [], id: 2 },
      { title: '志愿讲堂', list: state.cmsData.lectureHall || [], id: 3 },
      { title: '招办动态', list: state.cmsData.admissionsCondition || [], id: 1, max: 4 }
    ])
  }, [state.cmsData])

  return (
    <div className={s.CollegeNews}>
      {newsList.map((v) =>
        v.list.length > 0 ? (
          <div key={v.title}>
            <p className={s.title}>
              <span>{v.title}</span>
              <button type="button" onClick={() => toDetail(v.id)} className={s.more}>
                更多 <img src={icon} alt="按钮" />
              </button>
            </p>
            <ul className={s.msgbox}>
              {v.list.slice(0, v.max || 8).map((item) => (
                <a
                  href={item.target}
                  target="_blank"
                  rel="noreferrer"
                  key={item.title}
                  onClick={() => msgClick(v.title, item.title)}
                >
                  <li>
                    <p className={s.msgTitle}>{item.title}</p>
                    <p className={s.msgDes}>{item.des}</p>
                    {/** 临时处理：隐藏志愿讲堂时间戳 */}
                    {v.id !== 3 && <p className={s.msgTime}>{item.time}</p>}
                    <img className={s.msgImg} src={item.img} alt="img" />
                  </li>
                </a>
              ))}
            </ul>
          </div>
        ) : null
      )}
    </div>
  )
}
export default CollegeNews
